import { render, staticRenderFns } from "./CoachingContainer.vue?vue&type=template&id=aa453f5c&"
import script from "./CoachingContainer.vue?vue&type=script&lang=ts&"
export * from "./CoachingContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports